'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of single user web
 */ const SingleUserWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9531",
                y: "31.6211",
                width: "63.9459",
                height: "37.2433",
                rx: "3.46892",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9531 62.1255V65.4044C19.9531 67.3203 21.5062 68.8734 23.422 68.8734H80.4301C82.346 68.8734 83.8991 67.3203 83.8991 65.4044V62.1255H19.9531Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1602",
                y: "68.8594",
                width: "19.6757",
                height: "6.04325",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2734",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "51.8729",
                cy: "48.6404",
                r: "11.0018",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("mask", {
                id: "mask0_3477_3566",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "40",
                y: "37",
                width: "23",
                height: "23",
                children: /*#__PURE__*/ jsxRuntime.jsx("circle", {
                    cx: "51.8729",
                    cy: "48.6404",
                    r: "11.0018",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                mask: "url(#mask0_3477_3566)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M51.8573 50.2485C54.4256 50.2485 56.5219 48.1611 56.5219 45.5773C56.5219 42.9934 54.4256 40.918 51.8573 40.918C49.2889 40.918 47.1914 43.0053 47.1914 45.5773C47.1914 48.1492 49.2877 50.2485 51.8573 50.2485Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M43.7887 54.6112C43.5898 55.1852 43.4175 55.7605 43.2812 56.3467C45.3979 58.6951 48.456 60.1825 51.8371 60.1825C55.2182 60.1825 58.3195 59.0587 60.4373 56.7103C60.3011 56.1241 60.0832 55.1864 59.8843 54.6112C59.1779 52.6118 57.6808 51.0746 55.8354 50.25C54.6963 51.049 53.3101 51.5124 51.8359 51.5124C50.3617 51.5124 48.9755 51.0502 47.8364 50.2622C45.9789 51.0746 44.4927 52.624 43.7875 54.6112H43.7887Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            })
        ]
    });
};

exports.SingleUserWeb = SingleUserWeb;
//# sourceMappingURL=SingleUserWeb.cjs.map
